import {
	createBrowserRouter,
	Navigate,
	RouterProvider,
} from 'react-router-dom';

import { HelmetProvider } from 'react-helmet-async';

import { Home } from './home/Home';
import { IssueView } from '../../views/issue/Issue';
import Drafts from '../../views/drafts/Drafts';
import config from '../../config';

import './App.css';
import { useTrackingInstallion } from '../../tracking/Tracking.hooks';
import { Callback } from './Callback';
import { Auth } from './auth/Auth';

function App() {
	const basename = config?.build?.subdirectory
		? config.build.subdirectory
		: undefined;
	useTrackingInstallion();
	const routes = [
		{
			path: '/',
			element: (
				<Auth>
					<Home />
				</Auth>
			),
		},
		{
			path: '/callback',
			element: <Callback />,
		},
		{
			path: '/issues/:id',
			element: (
				<Auth>
					<IssueView />
				</Auth>
			),
		},
		{
			path: '/issues/:id/:articleId',
			element: (
				<Auth>
					<IssueView />
				</Auth>
			),
		},
		{
			path: '*',
			element: <Navigate to="/" replace />,
		},
	];

	if (config?.app?.admin) {
		routes.push({
			path: '/drafts',
			element: <Drafts />,
		});
	}

	const router = createBrowserRouter(routes, {
		basename,
	});

	const classNames = ['App'];
	if (config.app.contentProtection) {
		// classNames.push('content-protection');
	}

	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
